import React, { Component } from 'react';
import '../../Common/shared.css'
import '../style.css';

import T from 'i18n-react';
import PersonalInfoForm from '../../Common/personalInfoForm'
import YesNoQuestion from '../../Common/yesNoQuestion'
import HighlightedSection from '../../Interview/highlightedSection'
import InterviewTitleProgress from '../../Common/interviewTitleProgress'
import SINTextInput, { isValidSIN } from '../../Common/sinTextInput'
import { isValidBirthdate } from '../../Common/dateTextInput'
import { isValidMessage } from '../../Register/services/registrationUtils'
import ValidatingTextInput from '../../Common/validatingTextInput'
import deleteIcon from '../../../images/deleteIcon.svg'
import addCircleIcon from '../../../images/addCircleIcon.svg'

class InterviewPage8 extends Component
{
    constructor(props)
    {
        super(props)

        var dependants = this.props.dependants && this.props.dependants.length > 0
            ? this.props.dependants
            : [{
                firstName: '',
                middleName: '',
                lastName: '',
                dob: '',
                gender: '',
                relationship: '',
                livesWith: '',
                infirm: '',
                natureOfInfirmity: '',
                hasIncome: '',
                sin: ''
            }]

        this.state = {
            dependants,
            missingRequiredField: this.props.missingRequiredField,
            layoutType: this.props.layoutType,
            lang: this.props.lang,
            confirmRemoveIndex: null
        }
    }

    componentWillReceiveProps(newProps)
    {
        if (this.state.missingRequiredField !== newProps.missingRequiredField)
        {
            this.setState({ missingRequiredField: newProps.missingRequiredField })
        }
        if (newProps.dependants && newProps.dependants !== this.state.dependants)
        {
            this.setState({ dependants: newProps.dependants })
        }
        if (this.state.layoutType !== newProps.layoutType) {
            this.setState({ layoutType: newProps.layoutType })
        }
        if (this.state.lang !== newProps.lang) {
            this.setState({ lang: newProps.lang })
        }
    }

    onPersonalInfoChanged(index, personalInfo)
    {
        var dependants = [...this.state.dependants]
        dependants[index] = {
            ...dependants[index],
            firstName: personalInfo.firstName,
            middleName: personalInfo.middleName,
            lastName: personalInfo.lastName,
            gender: personalInfo.gender,
            dob: personalInfo.dob
        }
        this.setState({ dependants })
        if (this.props.onDependantsChanged)
        {
            this.props.onDependantsChanged(dependants)
        }
    }

    onDependantPropertyChanged(index, ev, value)
    {
        var dependants = [...this.state.dependants]
        dependants[index] = {
            ...dependants[index],
            [ev.target.name]: value
        }
        this.setState({ dependants })
        if (this.props.onDependantsChanged)
        {
            this.props.onDependantsChanged(dependants)
        }
    }

    onYesNoChange(index, ev, value)
    {
        var dependants = [...this.state.dependants]
        dependants[index] = {
            ...dependants[index],
            [ev.target.name]: value
        }
        this.setState({ dependants })
        if (this.props.onDependantsChanged)
        {
            this.props.onDependantsChanged(dependants)
        }
    }

    isDepValid(dep) {
        var hasName = dep.firstName && dep.firstName.trim().length > 0 && dep.lastName && dep.lastName.trim().length > 0;
        var hasDob = dep.dob && isValidBirthdate(dep.dob, false, false).valid;
        var isQC = this.props.residenceProvince === 'QC';
        var hasValidSin = dep.hasIncome !== 'Y' || isValidSIN(dep.sin);
        return hasName && hasDob && (!isQC || Boolean(dep.gender)) && Boolean(dep.relationship) &&
            Boolean(dep.livesWith) && Boolean(dep.infirm) && Boolean(dep.hasIncome) && hasValidSin;
    }

    onAddDependant()
    {
        var allValid = this.state.dependants.every(dep => this.isDepValid(dep));
        if (!allValid) {
            this.setState({ missingRequiredField: true });
            return;
        }
        var dependants = [...this.state.dependants, {
            firstName: '',
            middleName: '',
            lastName: '',
            dob: '',
            gender: '',
            relationship: '',
            livesWith: '',
            infirm: '',
            natureOfInfirmity: '',
            hasIncome: '',
            sin: ''
        }]
        this.setState({ dependants })
        if (this.props.onDependantsChanged)
        {
            this.props.onDependantsChanged(dependants)
        }
    }

    onRemoveDependant(index)
    {
        this.setState({ confirmRemoveIndex: index })
    }

    confirmRemove()
    {
        var dependants = [...this.state.dependants]
        dependants.splice(this.state.confirmRemoveIndex, 1)
        this.setState({ dependants, confirmRemoveIndex: null })
        if (this.props.onDependantsChanged)
        {
            this.props.onDependantsChanged(dependants)
        }
    }

    cancelRemove()
    {
        this.setState({ confirmRemoveIndex: null })
    }

    renderDependant(dependant, index)
    {
        var isMobile = this.state.layoutType === 'mobile'
        var showRemoveButton = this.state.dependants.length > 1

        return (
            <div key={index} className="dep-dependant-section">
                {index > 0 && <div className="dep-separator-line"></div>}
                <HighlightedSection {...this.props} margin={20}>
                <div margin={20}>
                    {showRemoveButton && (
                        <div className="dep-dependant-header-row">
                            <h3 className="dep-dependant-header">
                                {T.translate("Interview.Page8.dependentHeader", { DependentNumber: index + 1 })}
                            </h3>
                            <button
                                type="button"
                                className="dep-remove-button"
                                onClick={() => this.onRemoveDependant(index)}
                            >
                                <img src={deleteIcon} alt="" width="20" height="20" />
                                <span>{T.translate("Interview.Page8.removeButton")}</span>
                            </button>
                        </div>
                    )}
                    <PersonalInfoForm missingRequiredField={this.state.missingRequiredField} page={'page8'}
                        lang={this.state.lang} residenceProvince={this.props.residenceProvince}
                        dependantVersion allRequiredFields labelKey="Interview.Page1" personalInfo={dependant}
                        onPersonalInfoChanged={(personalInfo) => this.onPersonalInfoChanged(index, personalInfo)}
                        onDependantPropertyChanged={(ev, value) => { this.onDependantPropertyChanged(index, ev, value) }} />
                    <div className="dep horizontalFieldContainerTopAligned questionMargin">
                        <YesNoQuestion name="livesWith" value={dependant.livesWith}
                            layoutType={this.state.layoutType} learnMoreId="OTE_FAQ/OTEDoesThisDependantLiveWithYou"
                            labelText={T.translate("Interview.Page8.fieldLabel1", { TaxYear: this.props.taxYear })}
                            isRequired
                            missingRequiredField={this.state.missingRequiredField && !dependant.livesWith}
                            onAnswerChanged={(ev, value) => { this.onYesNoChange(index, ev, value) }} />
                    </div>
                    <div className="dep horizontalFieldContainerTopAligned questionMargin">
                        <YesNoQuestion name="infirm" value={dependant.infirm}
                            layoutType={this.state.layoutType} learnMoreId="Parent_Dependants/WasThisDependantInfirm"
                            labelText={T.translate("Interview.Page8.fieldLabel2", { TaxYear: this.props.taxYear })}
                            isRequired
                            missingRequiredField={this.state.missingRequiredField && !dependant.infirm}
                            onAnswerChanged={(ev, value) => { this.onYesNoChange(index, ev, value) }} />
                    </div>
                    {dependant.infirm === 'Y' && (
                        <div className="dep horizontalFieldContainerTopAligned questionMargin">
                            <div className="yesNoQuestionContainerStyle">
                                <div className="yesNoQuestionStyle dep-stacked-question">
                                    <div className="fixed inlineLabelStyle dep-infirmity-label-indent">
                                        <span className="dep-infirmity-question-text">{T.translate("Interview.Page8.fieldLabel4")}</span>
                                        <p className="dep-infirmity-hint">
                                            {T.translate("Interview.Page8.fieldLabel4_hint_prefix")}
                                            <a href="https://support.hrblock.ca/en-ca/Content/Parent_Dependants/WhatWasTheNatureOfHis_HerInfirmity.htm"
                                               target="_blank" rel="noopener noreferrer">
                                                {T.translate("Interview.Page8.fieldLabel4_link")}
                                            </a>
                                            {T.translate("Interview.Page8.fieldLabel4_hint_suffix")}
                                        </p>
                                    </div>
                                    <div className="yesNoButtonContainer">
                                        <ValidatingTextInput
                                            name="natureOfInfirmity"
                                            value={dependant.natureOfInfirmity || ''}
                                            maxLength={30}
                                            validateOnChange
                                            validationFailedText={T.translate("Common.Errors.InvalidChars")}
                                            validator={(value) => isValidMessage(value)}
                                            onChange={(ev, newValue) => this.onDependantPropertyChanged(index, ev, newValue)}
                                        />
                                    </div>
                                </div>
                            </div>
                        </div>
                    )}
                    <div className="dep horizontalFieldContainerTopAligned questionMargin">
                        <YesNoQuestion name="hasIncome" value={dependant.hasIncome}
                            layoutType={this.state.layoutType} learnMoreId="OTE_FAQ/OTEDidThisDependantHaveAnyIncome"
                            labelText={T.translate("Interview.Page8.fieldLabel3", { TaxYear: this.props.taxYear })}
                            isRequired
                            missingRequiredField={this.state.missingRequiredField && !dependant.hasIncome}
                            onAnswerChanged={(ev, value) => { this.onYesNoChange(index, ev, value) }} />
                    </div>
                    {dependant.hasIncome === 'Y' && (
                        <div className="dep horizontalFieldContainerTopAligned questionMargin">
                            <div className="yesNoQuestionContainerStyle">
                                <div className="yesNoQuestionStyle dep-stacked-question">
                                    <div className="fixed inlineLabelStyle dep-sin-label-container">
                                        <span className="dep-sin-label">{T.translate("Interview.Page8.fieldLabel5_label") + '*'}</span>
                                        <span className="dep-sin-support">{T.translate("Interview.Page8.fieldLabel5_support", { DependentName: dependant.firstName || '' })}</span>
                                    </div>
                                    <div className="yesNoButtonContainer">
                                        <SINTextInput
                                            name="sin"
                                            value={dependant.sin || ''}
                                            isRequired={true}
                                            missingRequiredField={this.state.missingRequiredField}
                                            renderErrorBorderOnly={this.state.missingRequiredField && dependant.hasIncome === 'Y' && !isValidSIN(dependant.sin)}
                                            onChange={(ev) => this.onDependantPropertyChanged(index, ev, ev.target.value)}
                                        />
                                    </div>
                                </div>
                            </div>
                        </div>
                    )}
                </div>
            </HighlightedSection>
            </div>
        )
    }

    render()
    {
        var percentage = '66'
        if (this.props.spouseTaxes === 'N') {
            percentage = '72'
        }

        return (
            <div style={{ marginBottom: 0 }}>
                <div>
                    <div>
                        <InterviewTitleProgress taxYear={this.props.taxYear} percentage={percentage} title="Interview.Page8.headerTitle" nextTitle="Interview.Page8.nextTitle" />
                    </div>                      
                    <T.p text="Interview.Page8.headerContent0" className="headerText" />                    
                    <T.p text="Interview.Page8.headerContent1" className="headerText" />
                </div>
                {this.state.confirmRemoveIndex !== null && (
                    <div className="dep-remove-dialog-overlay">
                        <div className="dep-remove-dialog" role="dialog" aria-modal="true">
                            <h3 className="dep-remove-dialog-title">{T.translate('Interview.Page8.removeConfirmTitle')}</h3>
                            <p className="dep-remove-dialog-content">{T.translate('Interview.Page8.removeConfirmContent')}</p>
                            <div className="dep-remove-dialog-actions">
                                <button type="button" className="dep-remove-dialog-remove-btn" onClick={() => this.confirmRemove()}>
                                    {T.translate('Interview.Page8.removeConfirmRemoveLabel')}
                                </button>
                                <button type="button" className="dep-remove-dialog-back-btn" onClick={() => this.cancelRemove()}>
                                    {T.translate('Interview.Page8.removeConfirmBack')}
                                </button>
                            </div>
                        </div>
                    </div>
                )}
                {this.state.dependants.map((dependant, index) => this.renderDependant(dependant, index))}
                {this.state.dependants.length > 1 && <div className="dep-separator-line"></div>}
                <div className="inFormControlContainer">
                    <div tabIndex="0" className="addDependantButton" onClick={() => this.onAddDependant()} onKeyDown={(ev) => { if (ev.key === 'Enter' || ev.key === ' ') this.onAddDependant() }}>
                        <span className="addDependantButtonIcon">
                            <img src={addCircleIcon} alt="" width="20" height="20" />
                        </span>
                        <span className="addDependantButtonText"><T.span text={{ key: 'Interview.Page8.addAnotherButton' }} /></span>
                    </div>
                </div>
            </div>
        )
    }
}

export default InterviewPage8;